import { render, staticRenderFns } from "./EditUserSidebar.vue?vue&type=template&id=47b80379&scoped=true"
import script from "./EditUserSidebar.vue?vue&type=script&lang=js"
export * from "./EditUserSidebar.vue?vue&type=script&lang=js"
import style0 from "./EditUserSidebar.vue?vue&type=style&index=0&id=47b80379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b80379",
  null
  
)

export default component.exports